<template>
  <FormContainer>
    <template #title>Adresse d’exécution du contrat</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_4"
          :model-value="model?.employeur?.etablissement?.adresse?.voie"
          :label="LABEL_NUMERO_VOIE"
          class="col-10 col-md-18 col-sm-36"
          :required="meta.employeur?.etablissement?.adresse?.voie?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.adresse?.voie?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_4"
          :model-value="model?.employeur?.etablissement?.adresse?.complement"
          label="Complément d'adresse"
          class="col-10 col-md-18 col-sm-36"
          :required="meta.employeur?.etablissement?.adresse?.complement?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.adresse?.complement?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_4"
          :model-value="model?.employeur?.etablissement?.adresse?.codePostal"
          label="Code postal"
          class="col-6 col-md-8 col-sm-36"
          :required="meta.employeur?.etablissement?.adresse?.codePostal?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.adresse?.codePostal?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_4"
          :model-value="model?.employeur?.etablissement?.adresse?.commune"
          label="Commune"
          class="col-10 col-md-18 col-sm-36"
          :required="meta.employeur?.etablissement?.adresse?.commune?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.adresse?.commune?.$messageErreurDirty!"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInputTelephone
          id="field_5"
          v-model="telephoneModel"
          label="Téléphone"
          class="col-8 col-md-10 col-sm-36"
          :placeholder="PLACEHOLDER_TEL"
          :required="meta.employeur?.contact?.telephone?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.contact?.telephone?.$messageErreurDirty!"
          deletable
          :maxlength="10"
          :readonly
        />
        <WrapperInput
          id="field_6"
          v-model="emailModel"
          label="Email"
          class="col-12 col-md-16 col-sm-36"
          :placeholder="PLACEHOLDER_EMAIL"
          hint="200 caractères maximum"
          :required="meta.employeur?.contact?.email?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.contact?.email?.$messageErreurDirty!"
          deletable
          :maxlength="200"
          :readonly
          :help="emailHelp"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeCPROStore } from '@/features/interface/demande/cpro/useDemandeCPROStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import {
    FormContainer,
    LABEL_NUMERO_VOIE,
    PLACEHOLDER_EMAIL,
    PLACEHOLDER_TEL,
  } from '@/features/interface/demande/shared'
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'

  const store = useDemandeCPROStore()
  const { setupFieldWithKey } = store
  const { meta, model, readonly, typeContextCourant } = storeToRefs(store)

  const telephoneModel = setupFieldWithKey<string>('employeur.contact.telephone', true)
  const emailModel = setupFieldWithKey<string>('employeur.contact.email', true)
  const emailHelp = computed(() => {
    return typeContextCourant.value === TypesContextesAutorisesEnum.Adherent
      ? undefined
      : 'Renseigner ici l’Email de l’employeur ou à défaut l’Email de votre contact entreprise'
  })
</script>
